
    import axios from 'axios'
    import store from '../store/index.js'

    export default {
        async add_badges(params)  {
            return await axios.post('badges/create.php' , params)
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async get_badges()  {
            // return await axios.get('badges/read.php')
            // .then(r =>{
            //     return r
            // })
            // .catch(e =>{
            //     console.log(e);
            // })
            store.commit('get_badges')
        },
        async delete_badges(badge_id)  {
            return await axios.post('badges/delete.php' , {
                badge_id : badge_id
            })
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async getOne(badge_id)  {
            return await axios.post('badges/readOne.php' , {
                badge_id : badge_id
            })
            .then(r =>{
                return r
                
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async update_badges(params)  {
            return await axios.post('badges/update.php' , params)
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async report_badges(params)  {
            return await axios.post('badges/report.php',params)
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
    }
